import "../../styles/base.scss";
import "../../components/welcomeScreen/welcome.scss";

import React, { Fragment, PureComponent } from "react";

import FormButton from "../../components/form/FormButton";
import standardValidator from "../../dataConversion/standardFormat/standardValidator";
import { loadData } from "../../nativeComms/nativeCommsReceiver";

class HarvardWelcomeScreen extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isValid: true,
      error: false,
      loading: false,
      generateUrl: false,
      generatedUrl: null
    };

    this.inputRef = React.createRef();
    this.onInputChange = this.onInputChange.bind(this);
    this.validateUrl = this.validateUrl.bind(this);
    this.generateUrl = this.generateUrl.bind(this);

    // Get the query string
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let encodedUri = params.get("tsf");
    let generalUrl = params.get("generateUrl");

    if (typeof generalUrl === "string") {
      this.state.generateUrl = true;
    } else if (encodedUri) {
      this.state.loading = true;
    }
  }

  componentDidMount() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let encodedUri = params.get("tsf");
    if (encodedUri) {
      let decodedUri = decodeURIComponent(encodedUri);
      if (decodedUri) {
        fetch(decodedUri)
          .then(res => res.json())
          .then(result => {
            const valid = standardValidator(result);
            if (!valid) {
              throw "Invalid file";
            }
            try {
              loadData(result, false, true, false, false);
            } catch (err) {
              // eslint-disable-next-line no-console
              console.log(err);
              throw "Load error";
            }
          })
          .catch(_error => {
            this.setState({ error: true, loading: false });
          });
      }
    }
  }

  onInputChange() {
    if (!this.state.isValid) {
      const valid = this.validateUrl();
      this.setState({
        isValid: valid
      });
    }
  }

  validateUrl() {
    const uri = this.inputRef.current.value;
    const regex = /(http|https):\/\/([wW]{3}\.)?(\S+)(:[0-9]+)?(\/)(\S+)(\.(tsf)$)/;
    return regex.test(uri);
  }

  generateUrl() {
    const uri = this.inputRef.current.value;
    const valid = this.validateUrl();
    this.setState({
      isValid: valid,
      generatedUrl: valid ? encodeURIComponent(uri) : null
    });
  }

  render() {
    if (this.state.generateUrl) {
      const text = `<iframe src="${window.location.protocol}//${window.location.host}${window.location.pathname}?tsf=${this.state.generatedUrl}" style="width: 100%; height: 700px"></iframe>`;
      return (
        <div className="aeonWelcome">
          <div className="welcomeRightContainer">
            <div className="modalField" style={{ width: "auto" }}>
              <div className="row">
                <h1>Generate Embeddable Timeline Code</h1>
                {this.state.isValid ? (
                  <p>Please enter the URL of your .tsf timeline:</p>
                ) : (
                  <p className="warning">Please enter a valid URL to a .tsf file:</p>
                )}
                <input
                  type="url"
                  style={{ width: "380px" }}
                  placeholder="http://www.yourwebsite.com/timeline.tsf"
                  ref={this.inputRef}
                  onChange={this.onInputChange}
                />
                <FormButton label="Generate Code" primary={true} onClick={this.generateUrl} />
                {this.state.isValid && this.state.generatedUrl ? (
                  <Fragment>
                    <p>Copy and paste this code on your website:</p>
                    <textarea value={text} readOnly={true} style={{ width: "500px", height: "100px" }} />
                  </Fragment>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.loading) {
      return (
        <div className="aeonWelcome">
          <div className="welcomeRightContainer">
            <div>
              <div className="row" style={{ textAlign: "center" }}>
                <h3>Loading...</h3>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.error) {
      return (
        <div className="aeonWelcome">
          <div className="welcomeRightContainer">
            <div>
              <div className="row" style={{ textAlign: "center" }}>
                <h1>Timeline Viewer</h1>
                <p>An error has occurred. File could not be loaded.</p>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="aeonWelcome">
        <div className="welcomeRightContainer">
          <div>
            <div className="row" style={{ textAlign: "center" }}>
              <h1>Timeline Viewer</h1>
              <p>No timeline selected.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HarvardWelcomeScreen.propTypes = {};

export default HarvardWelcomeScreen;
